<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/batches/${$route.params.idBatch}/acompanhamento`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para o painel de
              acompanhamento do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent d-flex align-items-stretch"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="admin"
            endPage="acompanhamento"
            class="flex-grow-1"
          />
        </div>
        <div
          class="col-lg-8 mt-lg-0 mt-3 vld-parent d-flex align-items-stretch"
          ref="card_stats"
        >
          <card shadow type="secondary" class="flex-grow-1">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Painel mensal da Startup -
                    <span class="text-warning">{{
                      startup.name || "..."
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <startup-metrics
                :data="startup.responses"
                title="Indicadores de desempenho do último mês"
              />
            </div>
          </card>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card shadow type="secondary">
            <div class="col-12 vld-parent" ref="list_cards">
              <div v-if="empty">
                <div class="row">
                  <div class="col-12 text-center">
                    <badge type="warning" class="bg-white">
                      Nenhum card personalizado foi vinculado à startup até o
                      momento
                    </badge>
                  </div>
                </div>
              </div>
              <div v-else>
                <CustomCardList
                  :data="cards"
                  v-if="cards.length"
                  :showEditLink="true"
                />
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";
import StartupMetrics from "@/components/StartupDashboard/StartupMetrics";
import CustomCardList from "@/components/CustomCardList";
import api from "@/services/api";

export default {
  name: "admin_startup_metrics",
  components: {
    StartupBatchInfo,
    StartupMetrics,
    CustomCardList,
  },
  data() {
    return {
      batch: "",
      startup: "",
      cards: "",
      empty: "",
    };
  },
  async mounted() {
    const loaderStartup = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
    });
    const loaderStats = this.$loading.show({
      container: this.$refs.card_stats,
      width: 140,
      height: 140,
    });
    try {
      const { data } = await api.get(
        `/batches/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}/metrics`
      );
      if (!data.batch) throw new Error("Batch not found");
      if (!data.startup) throw new Error("Startup not found");
      this.batch = data.batch;
      this.startup = data.startup;
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
      loaderStartup.hide();
      loaderStats.hide();
      await this.loadCards();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao carregar informações");
    }
  },
  methods: {
    async loadCards() {
      const loaderCards = this.$loading.show({
        container: this.$refs.list_cards,
        width: 140,
        height: 140,
      });
      try {
        const { data: cards } = await api.get(
          `/startup-cards/batches/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}`
        );
        if (!cards.length) this.empty = true;
        else this.cards = cards;
        loaderCards.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar os cards");
      }
    },
  },
};
</script>
